export const REQUEST_KEYS = {
  departmentsData: 'DEPARTMENTS_DATA',
};
